module.exports = __webpack_public_path__ + "static/rot_troll-c9bae6cebe232be7d09fa483afeca846.png";